<template>
	<div class="main-div-chart" :style="{ height: data_height + 'px' }">
		<chart-sub :constructor-type="chartType" :options="option" ref="chart" :key="key"
			:callback="created" :style="'height:' + data_height + 'px;'"></chart-sub>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import stockInit from 'highcharts/modules/stock'
import { fomatTimeStr } from "@/components/common/utils/time";

stockInit(Highcharts)
export default {
	data() {
		return {
			key: 0,
		}
	},
	props: {
		option: {
			type: Object
		},
		data_height : {
			type: Number
		},
		chartType:{
			default: 'chart'
		}
	},
	components: {
		'chart-sub': Chart
	},
	mounted() {
		Highcharts.dateFormats = {
			w : fomatTimeStr
		}
	},
	created() {
	},
	methods : {
		created : function(e) {
			this.$emit('created', e)
		},
	},
	watch: {
		option: {
			handler() {
				// 这里给chart一个key,每次更新option时重新绘制组件
				this.$data.key = this.$data.key + 1
			},
			deep: true
		}
	}
}
</script>
<style scoped>
.main-div-chart{
	width: 100%;
}
</style>